module.exports = __webpack_public_path__ + "img/sunFlower-1.b7c88d88.jpeg";